<template>
  <div class="LkBackLink">
    <router-link :to="to" class="LkBackLink__link">
      <v-icon size="14px" v-text="'mdi-chevron-double-left'" />
      <span>Назад</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'LkBackLink',
  props: {
    to: {
      type: [String, Object],
      required: true,
    },
  },
}
</script>

<style lang="scss">
.LkBackLink {
  &__link {
    color: $webflow-color-blue-dark-hover;
    text-decoration-line: none;

    &:hover {
      color: $webflow-color-blue-dark;
    }
  }
}
</style>
